module.exports = __webpack_public_path__ + "static/media/twitter.dbf33e4b.svg";